import React from 'react';
import Paper from '@mui/material/Paper';

import styles from 'src/components/alerts/AlertCard.module.css';

type AlertCardProps = {
    icon: React.ReactNode;
    title: string;
    description: string;
    actions: React.ReactNode;
    borderColor: string;
};

export default function AlertCard({ icon, title, description, actions, borderColor }: AlertCardProps) {
    return (
        <Paper
            elevation={3}
            className={styles.card}
            style={{ '--alert-color': borderColor } as React.CSSProperties}
        >
            <div className={styles.body}>
                <div className={styles.iconWrap}>
                    {icon}
                </div>
                <div className={styles.content}>
                    <span className={styles.title}>{title}</span>
                    <span className={styles.description}>{description}</span>
                    <div className={styles.actions}>{actions}</div>
                </div>
            </div>
        </Paper>
    );
}
